// exports FaxStatus - an immutable object 'enum'
// usage: import { FaxStatus } from '../../enums/FaxStatus';
const faxStatuses = {
    Errored: -100,
    Created: 10,
    Sending: 50,
    Sent: 100
};
Object.freeze(faxStatuses);
export const FaxStatus = faxStatuses;